import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=d1af691a&"
import script from "./Thanks.vue?vue&type=script&lang=js&"
export * from "./Thanks.vue?vue&type=script&lang=js&"
import style0 from "./Thanks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports